import { linkStyles } from "@/styles/typography";
import styled from "styled-components";

export const Banner = styled.div`
  color: ${(props) => props.theme.colors.dark};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100%;
  background: ${(props) => props.theme.gradients.light1};
  padding: 0.6rem;
  display: flex;
  justify-content: center;
`;

export const BannerContent = styled.div`
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1rem;
  max-width: 1200px;
  ${linkStyles}
`;
